import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/bootstrap-vue';
import './plugins/vuelidate';
import './plugins/axios';
import './plugins/vue-notification';
import './plugins/ns-common-web-re';
import './plugins/vue-cookies';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
